import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const { Text } = Typography;

const MenuWrapper = styled.div`
  display: grid;
  gap: 6px;
  padding: 6px 0;
`;

interface ChangePasswordMenuProps {
  handleOnUpdate: (value: boolean) => void;
}

export const ChangePasswordMenu = ({ handleOnUpdate }: ChangePasswordMenuProps) => {
  const { t } = useTranslation();

  return (
    <MenuWrapper>
      <Text>*******</Text>
      <Button block type="default" size="small" htmlType="reset" onClick={() => handleOnUpdate(true)}>
        {t('changePassword.title')}
      </Button>
    </MenuWrapper>
  );
};
